import {useEffect} from "react";

export const useDebouncedEffect = (effect, deps: any[] = [], delay = 100) => {
  useEffect(effect, deps);
};
